module.exports = __webpack_public_path__ + "static/media/logo1.14a2f270.png";